<template>
  <div class="space-y-3">
    <UAlert
      v-if="ownerName"
      color="warning"
      variant="subtle"
      :title="`یک حساب با این شماره به نام ${ownerName} وجود دارد`"
      description="نسبت این فرد با صاحب شماره را مشخص کنید."
    />
    <UAlert
      v-else
      color="warning"
      variant="subtle"
      title="یک حساب با این شماره وجود دارد"
      description="نسبت این فرد با صاحب شماره را مشخص کنید."
    />
    <ul
      v-if="members.length"
      class="space-y-1 rounded-xl border border-[var(--ui-border)] p-3 text-sm"
    >
      <li
        v-for="(member, index) in members"
        :key="`${member.fullName}-${index}`"
        class="flex items-center justify-between gap-2"
      >
        <span class="font-medium">{{ member.fullName }}</span>
        <span class="text-[var(--ui-text-muted)]">{{ patientRelationLabel(member.relation) }}</span>
      </li>
    </ul>
    <UFormField
      label="نسبت با صاحب شماره"
      required
    >
      <USelect
        :model-value="modelValue"
        :items="relationItems"
        class="w-full"
        @update:model-value="$emit('update:modelValue', $event as PatientRelation)"
      />
    </UFormField>
  </div>
</template>

<script setup lang="ts">
import {
  PATIENT_RELATIONS,
  PATIENT_RELATION_LABELS,
  patientRelationLabel,
  type PatientRelation,
} from '~/constants/patient/relations'
import type { PatientMemberSummary } from '~/types/patient'

const props = defineProps<{
  modelValue?: PatientRelation
  members?: PatientMemberSummary[]
}>()

defineEmits<{
  'update:modelValue': [value: PatientRelation]
}>()

const members = computed(() => props.members ?? [])

const ownerName = computed(() => {
  const self = members.value.find((row) => row.relation === 'self')
  return self?.fullName || members.value[0]?.fullName || ''
})

const relationItems = computed(() =>
  PATIENT_RELATIONS.filter((key) => key !== 'self').map((value) => ({
    label: PATIENT_RELATION_LABELS[value],
    value,
  })),
)
</script>
